'use client';

import { CloudAccountsSettingsSection } from '@terra/ui-design-system';
import { usePermissions } from '../../../../hooks/usePermissions';
import {
  useAttachExternalNetworkCloudInventory,
  useDetachExternalNetworkCloudInventory,
  useExternalNetworkCloudInventoryAttachments,
  useSyncExternalNetworkCloudInventory,
  useUpdateExternalNetworkCloudAccountPolicy,
} from '../../../../hooks/api/useExternalNetworkCloudInventory';
import { useOpenWebAppPage } from '../../../../hooks/useOpenWebAppPage';
import { WEB_APP_PATHS } from '../../../../utils/webAppPaths';

export function ExternalCloudAccountsSettingsPanel({
  surfaceId,
}: {
  surfaceId: string;
}) {
  const { canManageApplications } = usePermissions();
  const openWebAppPage = useOpenWebAppPage();
  const { attachments, isLoading, isError } =
    useExternalNetworkCloudInventoryAttachments({ surfaceId });
  const attach = useAttachExternalNetworkCloudInventory();
  const detach = useDetachExternalNetworkCloudInventory();
  const sync = useSyncExternalNetworkCloudInventory();
  const updatePolicy = useUpdateExternalNetworkCloudAccountPolicy();

  return (
    <CloudAccountsSettingsSection
      attachments={attachments}
      isLoading={isLoading}
      isError={isError}
      isReadOnly={!canManageApplications}
      pending={{
        isAttaching: attach.isPending,
        isDetaching: detach.isPending,
        isSyncing: sync.isPending,
        isUpdatingPolicy: updatePolicy.isPending,
      }}
      onAttach={(body) => attach.mutateAsync({ surfaceId, body })}
      onDetach={(body) => detach.mutateAsync({ surfaceId, body })}
      onSync={(body) => sync.mutateAsync({ surfaceId, body })}
      onUpdatePolicy={({ accountId, body }) =>
        updatePolicy.mutateAsync({ surfaceId, accountId, body })
      }
      onOpenIntegrations={() => openWebAppPage(WEB_APP_PATHS.integrations)}
    />
  );
}
